import * as overviewTypes from './overviewTypes';

const initialState = {
  caseManagerId: null,
  tableData: [],
  filters: {},
  caseDocuments: [],
  showFilterModal: false,
  isLoading: false,
  overviewFilter: {},
  primaryServiceRepresentative: null,
  secondaryServiceRepresentative: null,
  serviceRepresentativeList: [],
  overviewCaseAdditionalInfoDetails: {},
  openCaseTableData: [],
  overviewTableData:[],
};

const overviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case overviewTypes.GET_OVERVIEW_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    case overviewTypes.SET_OVERVIEW_CASES_PARAMS_SUCCESS: {
      return { ...state, casesPayload: action.payload };
    }
    
    case overviewTypes.SET_OVERVIEW_POPULATE_PAYLOAD_SUCCESS: {
      return { ...state, populatePayload: action.flag };
    }
    case overviewTypes.GET_OVERVIEW_CASES_SUCCESS: {
      return { ...state, tableData: action.payload };
    }

  
  
  
    case overviewTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    case overviewTypes.STORE_CASE_DETAILS:
      return {
        ...state,
        overviewCaseDetails: {
          ...action.overviewCaseDetails,
        },
      };
    case overviewTypes.STORE_OVERVIEW_ID:
      return {
        ...state,
        overviewId: action.overviewId,
      };
    case overviewTypes.RESET_OVERVIEW_ID:
      return {
        ...state,
        overviewId: null,
      };
    
    case overviewTypes.HYDRATE_CASES:
      return {
        ...state,
        caseDocuments: action.payload,
      };
   
    case overviewTypes.GET_OVERVIEW_CASE_REPRESENTATIVE_LIST_SUCCESS:
      const { primaryServiceRepresentative, secondaryServiceRepresentative, serviceRepresentativeList } = action.payload;
      return {
        ...state,
        primaryServiceRepresentative: primaryServiceRepresentative,
        secondaryServiceRepresentative: secondaryServiceRepresentative,
        serviceRepresentativeList: serviceRepresentativeList,
      };
    case overviewTypes.GET_OVERVIEW_CASE_ADDITIONAL_INFO_SUCCESS:
      return {
        ...state,
        overviewCaseAdditionalInfoDetails: action.payload,
      };
    case overviewTypes.GET_OVERVIEW_OPEN_CASES_SUCCESS:
      return {
        ...state,
        openCaseTableData: action.payload,
      };
    case overviewTypes.GET_OVERVIEW_DOCUMENTS_SUCCESS:
      return {
        ...state,
        overviewTableData: action.payload,
      };
    default:
      return state;
  }
};

export { initialState };
export default overviewReducer;
